import type { Site } from "@shared/types";

export type EmbeddedToolSiteSelectionMessage = {
  type: "tpc-seo:site-selection";
  payload: {
    siteId: string | null;
    siteName: string;
    primaryUrl: string | null;
    slug: string | null;
  };
};

export type EmbeddedToolReadyMessage = {
  type: "tpc-seo:embedded-ready";
};

export function buildEmbeddedToolSiteSelectionMessage(
  selectedSite: Site | null,
  selectedSiteLabel: string
): EmbeddedToolSiteSelectionMessage {
  return {
    type: "tpc-seo:site-selection",
    payload: {
      siteId: selectedSite?.id ?? null,
      siteName: selectedSite?.name ?? selectedSiteLabel,
      primaryUrl: selectedSite?.primary_url ?? null,
      slug: selectedSite?.slug ?? null,
    },
  };
}

export function isEmbeddedToolReadyMessage(
  value: unknown
): value is EmbeddedToolReadyMessage {
  return (
    typeof value === "object" &&
    value !== null &&
    "type" in value &&
    value.type === "tpc-seo:embedded-ready"
  );
}

export function postEmbeddedToolSiteSelection(
  target: Pick<Window, "postMessage">,
  origin: string,
  selectedSite: Site | null,
  selectedSiteLabel: string
) {
  target.postMessage(
    buildEmbeddedToolSiteSelectionMessage(selectedSite, selectedSiteLabel),
    origin
  );
}
